export class SetSelectedCompanyName {
  static readonly type = '[Selected Interview] Set selected Company name';
  constructor(public companyName: string) {}
}
